var render = function render(){var _vm=this,_c=_vm._self._c;return _c('styledLinkrapper',{staticClass:"archive-link-modul",attrs:{"hoverColor":_vm.currentTheme().select_color}},[_c('WpLink',{staticClass:"link-archive",attrs:{"url":_vm.link}},[_c('span',{staticClass:"text"},[_vm._t("default")],2),_c('StyledIcon',{staticClass:"icon",domProps:{"innerHTML":_vm._s(_vm.svgIcons.arrow2)}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }